import { connect } from "react-redux";
import Notfound from "./notfound";

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Notfound);
